import React, { useEffect, useState } from "react";
import { AdminSidebar } from "../Sidebar/Sidebar";
import { AdminTopBar } from "../topbar/Topbar";
import "../Quest/Quests.css";
import "../toggle.css";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import classroomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import TopImage from "../../common/TopImage";
import { InvoiceCards } from "./InvoiceCards";
import { useGetAllAgreementInvoices } from "../../../../hooks/admin/agreementInvoices/useGetAllAgreementInvoices";
import { useIssueInvoice } from "../../../../hooks/admin/agreementInvoices/useIssueInvoice";
import SuccessModal from "../../../common/SuccessModal";

export const AdminAllAgreementInvoices = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("all");
  const { issueInvoice, loading: issueLoading } = useIssueInvoice();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleIssueInvoice = async (invoiceId) => {
    try {
      await issueInvoice(invoiceId);
      // console.log("ISSUE SUCCESS"); // ✅ add this

      setShowSuccessModal(true);

      // ✅ refresh list after issuing
      await refetch();
    } catch (err) {
      // already handled in hook
    }
  };

  const { agreementInvoices, meta, stats, loading, refetch } =
    useGetAllAgreementInvoices({
      status: statusFilter,
      page: currentPage,
      perPage: 10,
    });

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  // when status changes → go to page 1
  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);

  const totalPages = meta?.last_page || 1;

  return (
    <div className="dashboardBody">
      <AdminSidebar isSidebarCollapsed={isSidebarCollapsed} />

      <div className="container-fluid p-0">
        <div id="mainContent">
          <AdminTopBar toggleSidebar={toggleSidebar} />

          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4 align-items-center">
                  <div className="col-12">
                    <BackButton />
                  </div>

                  <TopImage imageSrc={classroomImg} text="INVOICE MANAGEMENT" />

                  <div className="mt-4">
                    <InvoiceCards stats={stats}/>
                  </div>

                  <div className="col-md-4 my-4">
                    <p className="tchrdashboard-cmntitl mb-0">
                      SCHOOL INVOICES
                    </p>
                  </div>

                  <div className="col-md-4 my-4">
                    {/* search UI kept, but not wired to API yet */}
                    {/* <input
                      type="text"
                      className="form-control"
                      placeholder="Search invoices..."
                      disabled
                    /> */}
                  </div>

                  {/* <div className="col-md-4 text-md-end my-4">
                    <Link
                      to="#"
                      className="btn btn-primary text-white tchrdashboard-cmnbtn border-0"
                    >
                      <i className="fa fa-plus" aria-hidden="true"></i> Create
                      Invoice
                    </Link>
                  </div> */}
                </div>

                <div className="row mb-3">
                  <div className="col-md-2">
                    <select
                      className="form-select"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="paid">Paid</option>
                      <option value="issued">Issued</option>
                      <option value="draft">Draft</option>
                      <option value="partial">Partial</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>

                {/* ================== DESKTOP TABLE ================== */}
                <div className="d-md-block">
                  <div className="table-responsive">
                    <table className="table table-hover tchrtabl-pdng">
                      <thead className="quest-tablehead">
                        <tr>
                          <th>Invoice No.</th>
                          <th>School Name</th>
                          <th>Total Amount</th>
                          <th>Amount Paid</th>
                          <th>Issued Date</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody className="tchrtablbody">
                        {loading && (
                          <tr>
                            <td colSpan="8" className="text-center">
                              Loading invoices...
                            </td>
                          </tr>
                        )}

                        {!loading && agreementInvoices.length === 0 && (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No invoices found
                            </td>
                          </tr>
                        )}

                        {agreementInvoices.map((item) => (
                          <tr key={item.id}>
                            <td>{item?.invoice_no}</td>
                            <td>{item?.institution?.name || "-"}</td>
                            <td>{item?.currency === "INR" ? "₹" : "$"} 
                              {Number(item?.total_amount).toLocaleString("en-IN")}</td>
                            <td> {item?.currency === "INR" ? "₹" : "$"} {Number(item?.paid_amount).toLocaleString("en-IN")}</td>
                            <td>
                              {item?.issued_at
                                ? new Date(item.issued_at).toLocaleDateString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )
                                : "-"}
                            </td>

                            <td>
                              <span
                                className={`badge rounded-pill px-3 py-2 ${
                                  item?.status === "paid"
                                    ? "bg-success"
                                    : item.status === "issued"
                                    ? "bg-warning text-dark"
                                    : "bg-secondary"
                                }`}
                              >
                                {item.status.toUpperCase()}
                              </span>
                              {item.status === "draft" && (
                                <button
                                  className="mt-2 badge bg-primary border-0 p-2 rounded-pill"
                                  onClick={() => handleIssueInvoice(item.id)}
                                  disabled={issueLoading}
                                >
                                  {issueLoading
                                    ? "Issuing..."
                                    : "Issue Invoice"}
                                </button>
                              )}
                            </td>

                            <td className="text-center">
                              <Link
                                to={`/school/agreement/view/invoice/${item?.id}`}
                                className="pe-2"
                              >
                                <i
                                  className="fa fa-eye text-black"
                                  aria-hidden="true"
                                ></i>
                              </Link>{" "}
                              {/* <Link to={`#`}>
                                <img
                                  src="https://d2lvj32mp5x83n.cloudfront.net/static/superadmin/icons/edit.png"
                                  alt="Edit"
                                />
                              </Link> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* ================== MOBILE CARDS ================== */}
                <div className="d-none">
                  {loading && (
                    <div className="text-center py-3">Loading invoices...</div>
                  )}

                  {!loading && agreementInvoices.length === 0 && (
                    <div className="text-center py-3">No invoices found</div>
                  )}

                  {agreementInvoices.map((item) => (
                    <div className="card mb-3 shadow-sm" key={item.id}>
                      <div className="card-body py-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0 fw-bold">
                            {item?.institution?.name}
                          </h6>

                          <span
                            className={`badge ${
                              item?.status === "paid"
                                ? "bg-success"
                                : item?.status === "issued"
                                ? "bg-warning text-dark"
                                : "bg-secondary"
                            }`}
                          >
                            {item?.status?.toUpperCase()}
                          </span>
                        </div>

                        <p className="mb-1">
                          <strong>Invoice:</strong> {item?.invoice_no}
                        </p>

                        <p className="mb-1">
                          <strong>Total:</strong> ₹{item?.total_amount}
                        </p>

                        <p className="mb-1">
                          <strong>Paid:</strong> ₹{item?.paid_amount}
                        </p>

                        <p className="mb-2">
                          <strong>Date:</strong>{" "}
                          {new Date(item?.issued_at).toLocaleDateString(
                            "en-IN"
                          )}
                        </p>

                        <div className="d-flex gap-3 justify-content-end">
                          <Link to={`/agreement/view/${item.id}`}>
                            <i className="fa-regular fa-eye text-dark"></i>
                          </Link>

                          <Link to={`/agreement/edit/${item.id}`}>
                            <img
                              src="https://d2lvj32mp5x83n.cloudfront.net/static/superadmin/icons/edit.png"
                              alt="Edit"
                              width="18"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ================== PAGINATION ================== */}
                {totalPages > 1 && (
                  <div className="pagination">
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>

                    <button className="active">{currentPage}</button>

                    <button
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <SuccessModal
        showModal={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        title="Invoice Issued Successfully"
        message="Invoice has been issued successfully."
        primaryButtonText="Close"
        onPrimaryClick={() => setShowSuccessModal(false)}
      />
    </div>
  );
};
